import React, { Component } from 'react';
import '../css/getModalNotificacion.css';
class getModalNotificacion extends Component {
  render() {
    return (
      <div className="modal-dialog-notificacion">
        <div className="modal-content-notificacion">
          <div className="grid-container-menu-notificacion">
            <div className="div_menu_1-notificacion">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_salir_notificacion()} />
            </div>
            <div className="lbl_menu_2-notificacion">
              <span className="span-global-link">Notificación</span>
            </div>
          </div>
          <img  alt="Cargando Imagen . . ."  src={this.props.url_notificacion_modal} />
        </div>
      </div>
    );
  }
  componentDidMount (){
  }
}
export default getModalNotificacion;
